/**
 * Asset selector - loader module
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.dam.assetselector.loader');

goog.require('yext.dam.asset');
goog.require('yext.dam.routes');
goog.require('yext.imageloader');

/**
 * Stores a reference to the loaded asset
 */
yext.dam.assetselector.loader.loaded;

/**
 * Initialize loader module
 * @param {boolean} alwaysUploadPhoto
 */
yext.dam.assetselector.loader.init = function(alwaysUploadPhoto) {
  yext.imageloader.init({
    uploadEndpoint: goog.module.get('yext.dam.routes').default.uploadEndpoint(),
    externalImageUrlEndpoint: goog.module.get('yext.dam.routes').default.externalImageUrlEndpoint(),
    alwaysUploadPhoto,
  });

  $(yext.imageloader.events).on('add.imageloader', yext.dam.assetselector.loader.imageAdded);
  $(yext.imageloader.events).on('send.imageloader', yext.dam.assetselector.loader.imageSent);
};

/**
 * Image added callback
 *
 * @param {!Object} e Event
 * @param {!Object} image Image details
 */
yext.dam.assetselector.loader.imageAdded = function(e, image) {
  // Convert the image object to be compatible with asset
  image.photoUrl = image.url;
  image.name = image.fileName;
  delete image.url;
  delete image.fileName;

  yext.dam.assetselector.loader.loaded = yext.dam.asset.create(image);

  $(yext.dam.assetselector.loader).trigger('loaded.assetselector');
};

/**
 * Image sent callback
 *
 * @param {?} e
 * @param {string} url The url of the image
 */
yext.dam.assetselector.loader.imageSent = function(e, url) {
  if (typeof yext.dam.assetselector.loader.loaded == 'object') {
    yext.dam.assetselector.loader.loaded.photoUrl = url;

    // Delete any files because this has been uploaded
    delete yext.dam.assetselector.loader.loaded.file;
    delete yext.dam.assetselector.loader.loaded.fileInput;
  }
};

/**
 * Reset the state of the loader module
 */
yext.dam.assetselector.loader.reset = function() {
  yext.imageloader.resetImageOptions();
  yext.dam.assetselector.loader.loaded = undefined;
};
